import i18n from "../i18n";

import ValidationResult from "../interfaces/api/validation-result";

export const validateRoomName = (name: string | null, takenNames: string[] | null = null): ValidationResult => {

    if (name == null || name.trim().length === 0){
        return { isValid: false, error: i18n.t("validation-error-gate-name-empty")}
    }

    if (takenNames != null && takenNames.includes(name)) {
        return { isValid: false, error: i18n.t("error-room-duplicate-name") };
    }

    if (name.length > 80) {
        return { isValid: false, error: i18n.t("validation-error-name-too-long") };
    }

    const specialChars = /[`!@#$%^&*()+=[\]{};':"\\|,.<>/?~]/;
    if(specialChars.test(name)){
        return { isValid: false, error: i18n.t("validation-error-name-includes-special-chars") }
    }

    const umlauts = /[öäüÖÄÜ]/;
    if (umlauts.test(name)){
        return { isValid: false, error: i18n.t("validation-error-name-contains-umlauts") }
    }

    return { isValid: true, error: null };
}